import styled from "@emotion/styled";
import {
  Caption,
  Colors,
  FontSizes,
  Grid,
  Grids,
  LineHeights,
  MediaQueries,
  Spacings,
} from "@polestar/component-warehouse-react";

export const StyledGrid = styled(Grid)`
  margin-bottom: ${Spacings.large};

  ${MediaQueries.tablet} {
    margin-bottom: ${Spacings.xLarge};
  }

  ${MediaQueries.desktop} {
    margin-bottom: ${Spacings.xxLarge};
  }

  ${MediaQueries.desktopWide} {
    margin-bottom: ${Spacings.xxxLarge};
  }
`;

export const StyledMessage = styled(Caption)`
  color: ${Colors.black};
  white-space: pre-line;
  font-size: ${FontSizes.body};
  line-height: ${LineHeights.small};

  ${MediaQueries.tablet} {
    font-size: ${FontSizes.body};
    line-height: ${LineHeights.small};
  }

  ${MediaQueries.desktop} {
    font-size: ${FontSizes.body};
  }
`;

export const StyledInfoColumn = styled.div`
  grid-column: span ${Grids.tablet.columns};
  margin-bottom: ${Spacings.medium};

  ${MediaQueries.tablet} {
    grid-column: 1 / span ${Grids.tablet.columns};
  }

  ${MediaQueries.desktop} {
    grid-column: 3 / span ${Grids.tablet.columns};
    margin-bottom: ${Spacings.large};
  }

  ${MediaQueries.desktopWide} {
    grid-column: span 3;
  }
`;

export const StyledColumn = styled.div`
  grid-column: span ${Grids.tablet.columns};

  ${MediaQueries.tablet} {
    grid-column: 1 / span ${Grids.tablet.columns};
  }

  ${MediaQueries.desktop} {
    grid-column: 3 / span ${Grids.tablet.columns};
  }

  ${MediaQueries.desktopWide} {
    grid-column: 5 / span 6;
  }
`;
